import { useEffect } from "react";
import { getPrimaryColor, applyPrimaryColor } from "@/lib/auth";

export function ThemeProvider({ children }: { readonly children: React.ReactNode }) {
  useEffect(() => {
    const color = getPrimaryColor();
    if (color) applyPrimaryColor(color);
  }, []);

  return <>{children}</>;
}
